import axios from 'axios'

export default {
  namespaced: true,
  state: {
    snowflakeData: null
  },
  getters: {
    snowflakeTables (state) {
      const { snowflakeData } = state
      if (!snowflakeData) {
        return {}
      }

      const snowflakeTables = {}
      snowflakeData.tables.forEach(table => {
        const fullName = `${table.databaseName}.${table.schemaName}.${table.name}`
        snowflakeTables[fullName] = table.columns.map(column => column.name)
      })

      return snowflakeTables
    },

    snowflakeBlueprint (state) {
      const { snowflakeData } = state
      if (!snowflakeData) {
        return {}
      }

      const snowflakeBlueprint = {}
      Object.defineProperty(snowflakeBlueprint, 'type', {
        value: 'database',
        writable: false,
        enumerable: false
      })
      snowflakeData.tables.forEach(table => {
        if (!snowflakeBlueprint.hasOwnProperty(table.databaseName)) {
          snowflakeBlueprint[table.databaseName] = {}
          Object.defineProperty(snowflakeBlueprint[table.databaseName], 'type', {
            value: 'schema',
            writable: false,
            enumerable: false
          })
        }
        if (!snowflakeBlueprint[table.databaseName].hasOwnProperty(table.schemaName)) {
          snowflakeBlueprint[table.databaseName][table.schemaName] = {}
          Object.defineProperty(snowflakeBlueprint[table.databaseName][table.schemaName], 'type', {
            value: 'table',
            writable: false,
            enumerable: false
          })
        }
        snowflakeBlueprint[table.databaseName][table.schemaName][table.name] = {}
        Object.defineProperty(snowflakeBlueprint[table.databaseName][table.schemaName][table.name], 'type', {
          value: 'column',
          writable: false,
          enumerable: false
        })
        table.columns.forEach(col => {
          snowflakeBlueprint[table.databaseName][table.schemaName][table.name][col.name] = { type: col.type }
        })
      })

      return snowflakeBlueprint
    },

    snowflakeLastUpdated (state) {
      const { snowflakeData } = state
      if (!snowflakeData) {
        return {}
      }

      return snowflakeData.lastUpdated
    }
  },
  mutations: {
    setSnowflakeData (state, snowflakeData) {
      state.snowflakeData = snowflakeData
    }
  },
  actions: {
    fetchSnowflakeData ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_API_URI}/snowflake/snowflake-data`)
          .then(results => {
            if (!results.data.tables) {
              reject(new Error('No tables retrieved'))
            }

            const snowflakeData = {
              tables: results.data.tables.filter(table =>
                table.databaseName.toUpperCase() !== 'PRODUCTION_DATA' || ['PUBLIC', 'DM', 'HOMEBASE', 'BRAZE'].includes(table.schemaName.toUpperCase())
              ),
              lastUpdated: results.data.last_updated
            }

            commit('setSnowflakeData', snowflakeData)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
